export class PlacementChartsModel {
    placementChart: any = {};
}